import UserLoginSwitch from "../user-login-switch";
import { createCartCheckoutComponents } from "../../shared/cart/base-cart-checkout";
import PaymentMethod from "./payment-method";
import styles from "../index.module.scss";

const { CartCheckout, CartOrderDetails, CartSummary } =
  createCartCheckoutComponents({
    styles,
    UserLoginSwitch,
    PaymentMethod,
  });

export { CartOrderDetails, CartSummary };
export default CartCheckout;
